import { AppProvider } from "@core/providers";
import { ErrorBoundary } from "@core/components";
import AppRoutes from "@core/routes";

const App = () => {
  return (
    <AppProvider>
      <ErrorBoundary label="app">
        <AppRoutes />
      </ErrorBoundary>
    </AppProvider>
  );
};

export default App;
